import { Button, Typography } from "@mui/material";
import { ConfirmationDialog } from "~/components/ConfirmationDialog/ConfirmationDialog";
import { Flex } from "~/components/Flex";

interface SecurityPipelineGithubSetupResetProps {
  onOpenConfirmationDialog: () => void;
  onCloseConfirmationDialog: () => void;
  onConfirmConfirmationDialog: () => void;
  isConfirmationDialogOpen: boolean;
  isLoading: boolean;
}

export const SecurityPipelineGithubSetupReset = ({
  onOpenConfirmationDialog,
  onCloseConfirmationDialog,
  onConfirmConfirmationDialog,
  isConfirmationDialogOpen,
  isLoading,
}: SecurityPipelineGithubSetupResetProps) => {
  return (
    <Flex alignItems="flex-start" flexDirection="column" gap={1} mt={2}>
      <Button
        variant="outlined"
        size="large"
        color="error"
        onClick={onOpenConfirmationDialog}
      >
        Reset security pipeline
      </Button>
      <Typography variant="caption" color="text.secondary">
        Unpair all spaces, reset automations, and erase workflow history.
      </Typography>
      <ConfirmationDialog
        isOpen={isConfirmationDialogOpen}
        onClose={onCloseConfirmationDialog}
        onConfirm={onConfirmConfirmationDialog}
        title="Reset security pipeline"
        confirmButtonText="Reset"
        loading={isLoading}
        content={
          <Typography>
            Resetting will unpair all spaces, reset automations and regression
            behavior, and erase your workflow history.
          </Typography>
        }
      />
    </Flex>
  );
};
